import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '36px',
    whiteSpace: 'nowrap'
  },

  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),
    color: ({ isDue }) => (isDue ? theme.palette.indicator.red : 'inherit'),
    fontWeight: ({ isDue }) => (isDue ? theme.bold.bold : theme.bold.base)
  },

  completed: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
